import "./_fiduciary-column.scss";
import {MemberGroup, MemberGroupMember} from "src/ClientManagement/models/InvestorGroupType";
import {
    FamilyMembers,
    FiduciaryAssignment,
    FiduciaryKey,
    FiduciaryMemberType
} from "src/EstateFlowchart/model/EstateFlowchartTypes";
import React, {useEffect, useState} from "react";
import SuccessorTable from "src/EstateFlowchart/components/SuccessorTable/SuccessorTable";
import LoadingIndicator from "src/pages/LoadingIndicator";
import {parseFamilyMembers} from "src/EstateFlowchart/utils/DefUtils";

type FiduciaryColumnProps = {
    readonly familyMembers: MemberGroup,
    readonly member: MemberGroupMember
    readonly fiduciary: FiduciaryAssignment,
    readonly updateFiduciary: Function
}

const initialMemberItem = {
    label: "", selected: false, value: ""
}

const FiduciaryColumn: React.FC<FiduciaryColumnProps> = ({ familyMembers, member, fiduciary, updateFiduciary }: FiduciaryColumnProps): JSX.Element => {

    const [familyMembersResponse, setFamilyMembersResponse] = useState({} as FamilyMembers);

    useEffect(() => {
        let isMounted = true;
        const parsedFamilyMembersResponse = parseFamilyMembers(familyMembers);
        let item = initialMemberItem;
        item.label = parsedFamilyMembersResponse.label;
        item.value = parsedFamilyMembersResponse.value;
        parsedFamilyMembersResponse.familyMember.push(item);
        if (isMounted) setFamilyMembersResponse(parsedFamilyMembersResponse);

        document.getElementById("client-profile-scroll-container")?.scrollTo(0, 0)
        return () => {
            isMounted = false;
        }
    }, []);

    if (!(familyMembersResponse.familyMember) || familyMembersResponse.familyMember.length <= 0) {
        return <LoadingIndicator />;
    }

    return (
        <div className={"fiduciary-column"} data-testid={"fiduciary-column"}>
            <h4>{member?.firstName} {member?.lastName}</h4>
            <div className={"fiduciary-column__input-grid"}>
                <SuccessorTable formData={fiduciary}
                    successorType={FiduciaryMemberType.Executor}
                    updateData={updateFiduciary}
                    title={"Executor"}
                    buttonText={"ADD EXECUTOR"}
                    rowName={"NAME"}
                    customKey={FiduciaryKey.Executors} />
                <SuccessorTable formData={fiduciary}
                    successorType={FiduciaryMemberType.Guardian}
                    updateData={updateFiduciary}
                    title={"Guardian for Minors"}
                    buttonText={"ADD GUARDIAN"}
                    rowName={"NAME"}
                    includeNT={false}
                    customKey={FiduciaryKey.GuardiansForMinors}
                />
                <SuccessorTable formData={fiduciary}
                    successorType={FiduciaryMemberType.FiduciaryTrustee}
                    updateData={updateFiduciary}
                    title={"Trustees"}
                    buttonText={"ADD TRUSTEE"}
                    rowName={"NAME"}
                    customKey={FiduciaryKey.Trustees}
                />
                <SuccessorTable formData={fiduciary}
                    successorType={FiduciaryMemberType.FinancialPowerOfAttorney}
                    updateData={updateFiduciary}
                    title={"Financial Power of Attorney"}
                    buttonText={"ADD AGENT"}
                    rowName={"NAME"}
                    includeNT={false}
                    customKey={FiduciaryKey.FinancialPowerOfAttorneys}
                />
                <SuccessorTable formData={fiduciary}
                    successorType={FiduciaryMemberType.HealthcarePowerOfAttorney}
                    updateData={updateFiduciary}
                    title={"Healthcare Power of Attorney"}
                    buttonText={"ADD AGENT"}
                    rowName={"NAME"}
                    includeNT={false}
                    customKey={FiduciaryKey.HealthcarePowerOfAttorneys}
                />
            </div>
        </div>
    )
}

export default FiduciaryColumn;